import request from '@/utils/request'

// 查询商品分组列表分页
export function fetchList(query) {
    return request({
        url: '/taxation/prod/tag/page',
        method: 'get',
        params: query,
    })
}
// 查询商品分组详细
export function getObj(id) {
    return request({
        url: '/taxation/prod/tag/detail?id=' + id,
        method: 'get',
    })
}
//  新增商品分组
export function addObj(data) {
    return request({
        url: '/taxation/prod/tag/add',
        method: 'post',
        data: data,
    })
}
// 隐藏
export function statusObj(data) {
    return request({
        url: '/taxation/prod/tag/hide',
        method: 'post',
        data: data,
    })
}
// 修改商品分组
export function putObj(data) {
    return request({
        url: '/taxation/prod/tag/edit',
        method: 'post',
        data: data,
    })
}
// 删除商品分组
export function delObj(data) {
    return request({
        url: '/taxation/prod/tag/delete',
        method: 'post',
        data: data,
    })
}

// 商品分组标签商品(报单)分页
export function fetchList2(query) {
    return request({
        url: 'taxation/prod/tag/reference/page',
        method: 'get',
        params: query,
    })
}
// 商品分组标签商品(报单)分页
export function fetchList3(query) {
    return request({
        url: 'taxation/prod/tag/reference/page/unbound',
        method: 'get',
        params: query,
    })
}

/**
* 绑定产品
*
* @param data 需要绑定的产品信息
* @returns 返回请求的结果
*/
export function bindProduct(data) {
    return request({
        url: 'taxation/prod/tag/reference/add',
        method: 'POST',
       data,
    })
}
